import { useMemo } from "react";
import { useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { Chip } from "@material-ui/core";
import GuicheTableActions from "./components/table-action";
import SearchField from "../../../../../../../../../components/search-field";
import { useAttendanceLocalDepartmentGuicheList } from "../../../../../../../../../../../services/api-tansquery/attendance-local/department/guiche/list";
import { useAttendanceLocalStyles } from "../../../../../../../../../styles";
import { useListTabPanelStyles } from "./styles";
import EmptyState from "../../../../../../../../../../../Components/EmptyState";
import GuicheFormCreate from "../form/create";
import { attendanceTypes } from "../../../../../../../../../../../store/attendance-types";

export default function ListTabPanel() {
    const { slug, id } = useParams<{ slug: string, id: string }>();
    const { classes } = useListTabPanelStyles();
    const { classes: defaultClasses } = useAttendanceLocalStyles();
    const { data: guiches } = useAttendanceLocalDepartmentGuicheList({ setor: Number(id) });

    const isEmpty = useMemo(() => (
        (guiches?.results ?? []).length === 0
    ), [guiches]);

    return (
        <Paper elevation={3}>
            <Box className={classes.header}>
                <Box className={classes.search}>
                    <SearchField placeholder="Buscar guichê" />
                </Box>
                <GuicheFormCreate slug={slug} departmentId={Number(id)} />
            </Box>
            <TableContainer className={defaultClasses.tableContainer}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={defaultClasses.tableTH}>Ordem</TableCell>
                            <TableCell className={defaultClasses.tableTH}>Responsáveis</TableCell>
                            <TableCell className={defaultClasses.tableTH}>Tipo de Atendimento</TableCell>
                            <TableCell className={defaultClasses.tableTH}>Ativo</TableCell>
                            <TableCell className={defaultClasses.tableTH} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {guiches?.results.map((guiche) => (
                            <TableRow
                                hover
                                key={`guiche-${guiche.id}`}
                                role="checkbox"
                                tabIndex={-1}
                            >
                                <TableCell className={defaultClasses.tableCell}>
                                    {guiche.ordem}
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    <Box className={classes.chipsBox}>
                                        {guiche.users.map((user) => (
                                            <Chip key={`responsable-${user.id}`} label={user.first_name} />
                                        ))}
                                    </Box>
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    {attendanceTypes.find(
                                        (type) => type.value === guiche.tipo
                                    )?.label || "Não definido"}
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    <Box
                                        className={`${defaultClasses.badge} ${guiche.ativo
                                            ? defaultClasses.active
                                            : defaultClasses.inactive
                                            }`}
                                    >
                                        {guiche.ativo ? "Sim" : "Não"}
                                    </Box>
                                </TableCell>
                                <TableCell align="right" className={defaultClasses.tableCell}>
                                    <GuicheTableActions guiche={guiche} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {isEmpty && <EmptyState message="Nenhum guichê encontrado." />}
            </TableContainer>
        </Paper>
    );
}
